<template>
  <div>
    <p v-if="!error">Activating invitation...</p>
    <p
      v-else
      class="error">{{ error }}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import api from '@/helpers/api';
import tokenCheck from '@/helpers/guards/tokenCheck';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'Invitation',
  data() {
    return {
      error: '',
      SBIconList,
    };
  },
  destroyed() {
    this.finalizeSplashView();
  },
  mounted() {
    this.setSplashMessage('Checking invitation...');
    // console.log('MOUNTED ACTIVAION');
    if (this.$route.query.invite_token) {
      const inviteToken = this.$route.query.invite_token;
      const email = this.$route.query.email;
      // console.log('TOKEN:', inviteToken);

      api('POST', 'check-user-invitation-existence', { invite_token: inviteToken }, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            const params = {
              inviteToken,
              email: response.data.email,
              organisation: response.data.organisation,
            };
            if (response.data.user_exists && tokenCheck()) {
              this.acceptMerchantInvitation({ invite_token: inviteToken })
                .then((response) => {
                  if (response.status === 200) {
                    this.$router.push({ name: 'LoginPage', params });
                  }
                })
                .catch((error) => {
                  this.error = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Something went wrong. Please try again or contact support.';
                  window.eventBus.$emit('show-top-toast', { message: this.error, variant: 'danger', emojiIcon: 'warning' });
                  this.$router.push({ name: 'LoginPage' });
                });
            } else if (response.data.user_exists) {
              this.$router.push({ name: 'LoginPage', params });
            } else {
              this.$router.push({ name: 'RegisterPage', params });
            }
          } else {
            this.error = response.data.message || 'Something went wrong. Please try again or contact support.';
          }
        })
        .catch((error) => {
          this.error = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Something went wrong. Please try again or contact support.';
          window.eventBus.$emit('show-top-toast', { message: this.error, variant: 'danger', emojiIcon: 'warning' });
          this.$router.push({ name: 'LoginPage' });
        });
    } else {
      this.$router.push({ name: 'LoginPage' });
    }
  },
  methods: {
    ...mapActions({
      acceptMerchantInvitation: 'user/acceptMerchantInvitation',
      finalizeSplashView: 'organisation/finalizeSplashView',
      setSplashMessage: 'organisation/setSplashMessage',
    }),
  },
};
</script>
